import React from "react";
import styles from "./GalleryModal.module.css";
import cn from 'classnames';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Modal } from "react-bootstrap";
import CustomButton, { ButtonType } from "../../common/CustomButton/CustomButton";

interface IGalleryModalProps {
    showModal: boolean;
    onHide: () => void;
    gallery: string[];
    startIndex: number;
    className?: string;
};


const GalleryModal: React.FC<IGalleryModalProps> = ({showModal, onHide, gallery, startIndex, className}) => {
  
  return (
    <div className={cn(styles.customGoogleMap, className)}>
      <Modal
          show={showModal}
          onHide={onHide}
          size="lg"
          centered
        >
          <Modal.Body bsPrefix={cn(styles.modalBody)}>
            <CustomButton 
              btnType={ButtonType.NOSTYLE}
              onClick={onHide}
              className={styles.closeModalBtn}
            >
              Close
            </CustomButton>
            <Swiper
              modules={[Navigation]}
              navigation
              initialSlide={startIndex}
              className={styles.sliderWrap}
            >
              {gallery.map((img, idx) => (
                <SwiperSlide key={idx}>
                  <div className={styles.imageItem}>
                    <img src={img} alt={`slide-${idx}`} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Modal.Body>
        </Modal>
    </div>
  );
};

export default GalleryModal;
